// extracted by mini-css-extract-plugin
export default {"container":"CW-z","title":"DW-z","link":"EW-z"};